import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import collectionApiClient, {
  PopulatedDraftCollection,
} from "../../../api/collection";

const useCollectionsReviewInfiniteQuery = (textSearch: string) => {
  const queryClient = useQueryClient();
  const limit = 20;

  const fetchReviewedCollections = async (
    queryClient: ReturnType<typeof useQueryClient>,
    query: string,
    pageParam?: {
      skip?: number;
      limit?: number;
      returnCreator?: boolean;
    },
  ): Promise<PopulatedDraftCollection[]> => {
    const { skip = 0, limit = 20, returnCreator = true } = pageParam || {};
    const res = await collectionApiClient.getReviewedCollections(
      query,
      skip,
      limit,
      returnCreator,
    );

    res.forEach((collection) => {
      queryClient.setQueryData(["collection", collection.id], collection);
    });
    return res;
  };

  const { data, fetchNextPage, ...rest } = useInfiniteQuery<
    PopulatedDraftCollection[],
    Error
  >({
    queryKey: ["collections", textSearch],
    queryFn: ({ pageParam }) =>
      fetchReviewedCollections(
        queryClient,
        textSearch,
        pageParam as {
          skip?: number;
          limit?: number;
        },
      ),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.length < limit) {
        return undefined;
      }
      const currentLength = allPages.flat()?.length;
      return { skip: currentLength, limit };
    },
    initialPageParam: { skip: 0, limit },
  });

  return {
    data: data?.pages.flat(),
    fetchNextPage,
    ...rest,
  };
};

export default useCollectionsReviewInfiniteQuery;
